import 'core-js/es/array';

export default class Animation {

    constructor() {

        if (!window.IntersectionObserver) return;

        this.options = {
            rootMargin: '0px',
            threshold: "0",
        };

        window.addEventListener('load', () => {

            this.animations = Array.from(document.querySelectorAll('.js-ani'));
            this.jsNums = Array.from(document.querySelectorAll('.js-num'));

            console.log(this.animations);

            document.documentElement.className += ' js-loaded';
            if (this.animations) this.bindComponentAnimations();
            if (this.jsNums) this.bindNumberAnimations();

            this.downBtn = document.getElementById('js-down-btn');
            if (this.downBtn) this.bindDownBtn();
        });

        

    }

    bindDownBtn() {

        this.downBtn.addEventListener('click', (ev) => {

            const sections = document.querySelectorAll('.c-section');

            if (sections[0]) {
                sections[0].scrollIntoView();
                sections[0].focus();
            }

        });

    }

    bindComponentAnimations() {

        const observer = new IntersectionObserver((entries, observer) => {

            entries.forEach(entry => {

                if (entry.isIntersecting) {

                    setTimeout(() => { entry.target.classList.add('c-ani--animate'); }, 500);

                }

            });

        }, this.options);

        if (!!window.IntersectionObserver) {
            this.animations.forEach(el => { observer.observe(el); });
        } 

    }

    bindNumberAnimations() {

        const observer = new IntersectionObserver((entries, observer) => {

            entries.forEach(entry => {

                if (entry.isIntersecting) {

                    this.animateValue(entry);

                }

            });

        }, this.options);

        if (!!window.IntersectionObserver) {
            this.jsNums.forEach(el => { observer.observe(el); });
        } 

    }

    animateValue(el) {
        // assumes integer values for start and end

        var obj = el.target;

        if(obj.dataset.finished) return;

        const start = obj.dataset.from;
        const end = obj.dataset.to;
        const duration = obj.dataset.duration || 2000;

        const range = end - start;
        // no timer shorter than 50ms (not really visible any way)
        const minTimer = 50;
        // calc step time to show all interediate values
        let stepTime = Math.abs(Math.floor(duration / range));

        // never go below minTimer
        stepTime = Math.max(stepTime, minTimer);

        // get current time and calculate desired end time
        const startTime = new Date().getTime();
        const endTime = startTime + duration;
        let timer;

        function run() {
            var now = new Date().getTime();
            var remaining = Math.max((endTime - now) / duration, 0);
            var value = Math.round(end - (remaining * range));
            obj.innerHTML = value;
            if (value == end) {
                obj.dataset.finished = true;
                clearInterval(timer);
            }
        }

        timer = setInterval(run, stepTime);
        run();
    }

}